import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'kabas-legals-page-sales-conditions',
  templateUrl: './legals-page-sales-conditions.component.html',
})
export class LegalsPageSalesConditionsComponent {}
